export default __webpack_public_path__ + "static/media/calendar.646cf96a.svg";